// extracted by mini-css-extract-plugin
export default {"root":"LanguageSwitch_root__vB9fT"};